module.exports = __webpack_public_path__ + "img/phone-nature.37bbb594.png";